import { gql } from '@apollo/client';

const UpdateUserV2 = gql`
  mutation UpdateUserV2($input: UpdateUserV2Input!) {
    updateUserV2(input: $input)
  }
`;

export default UpdateUserV2;
